// extracted by mini-css-extract-plugin
export default {"page":"ZOte3","container":"zx5Sy","map":"YEOBo","mapPlaceholder":"qeSlZ","footer":"P1Z0Q"};